import { AppId, AppTextFieldHandler } from "../../../../app/appTypes"
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { Checkbox, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, TextField } from "@mui/material"
import { Localized } from "@fluent/react"
import { If } from "../../../../app/If"
import { showError, showSuccess } from "../../../notifications/notificationsSlice"
import { useCallback, useState } from "react"
import { createSysMailFooter, selectSysMailFooterById, updateSysMailFooter } from "./sysMailFootersSlice"
import { SaveButton } from "../../../../app/components/SaveButton"
import { CancelButton } from "../../../../app/components/CancelButton"


export interface SysMailTemplateDialogProps {
    id: AppId | undefined
    editable: boolean
    onSaveSuccess: () => void
    onCancel: () => void
}

export const SysMailFooterDialog = ({ id, editable,  onSaveSuccess, onCancel }: SysMailTemplateDialogProps) => {
    const dispatch = useAppDispatch()

    const entity = useAppSelector(state => selectSysMailFooterById(state, id ?? ""));
    const [name, setName] = useState<string>(entity?.name ?? "");
    const [footer, setFooter] = useState<string>(entity?.footer ?? "");
    const [isDefault, setIsDefault] = useState<boolean>(entity?.isDefault ?? false);
    const [saving, setSaving] = useState(false)

    const handleNameChange: AppTextFieldHandler = useCallback(e => setName(e.target.value), [setName]);
    const handleFooterChange: AppTextFieldHandler = useCallback(e => setFooter(e.target.value), [setFooter]);
    const handleIsDefaultChange = (event) => setIsDefault(event.target.checked);

    const handleSaveClick = async () => {
        setSaving(true)
        try {
            if(id === undefined && editable) {
                let template = {
                    name, footer, isDefault
                };

                await dispatch(createSysMailFooter(template)).unwrap()

                dispatch(showSuccess("saved"));
                onSaveSuccess()
            } else if (editable && entity) {
                let template = {
                    ...entity, name, footer, isDefault
                };

                await dispatch(updateSysMailFooter(template)).unwrap()

                dispatch(showSuccess("saved"));
                onSaveSuccess()
            }
            
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return <>
        <DialogTitle>
            <If condition={id !== undefined} otherwise={
                <Localized id="sys-mail-footers-new">
                    <span>_Nowa stopka</span>
                </Localized>
            }>
                <Localized id="sys-mail-footers-edit">
                    <span>_Edycja stopki</span>
                </Localized>
            </If>
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={2} padding={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        disabled={id !== undefined || !editable}
                        value={name}
                        inputProps={{ maxLength: 100 }}
                        onChange={handleNameChange}
                        label={<Localized id="sys-mail-footers-name">_Nazwa</Localized>}>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        value={footer}
                        minRows={6}
                        maxRows={12}
                        multiline
                        inputProps={{ maxLength: 10000 }}
                        onChange={handleFooterChange}
                        label={<Localized id="sys-mail-footers-content">_Treść stopki</Localized>}
                    />
                    <div dangerouslySetInnerHTML={{ __html: footer }} style={{ marginTop: 15, border: "1px solid #ccc", padding: "16px", backgroundColor: "#f9f9f9" }}/>
                </Grid>
                <Grid item>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isDefault}
                                    onChange={handleIsDefaultChange} />}
                            label={<Localized id="sys-mail-footers-is-default"><span>_Domyślne</span></Localized>}
                        />
                    </FormGroup>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <SaveButton loading={saving} onClick={handleSaveClick} />
            <CancelButton loading={saving} onClick={onCancel} />
        </DialogActions>
    </>
}